import { makeStyles } from "../../styles/index";
import React from 'react';
import { Card } from "../Card/Card";
import { CardContent } from "../Card/CardContent";
import { Typography } from "../Typography/Typography";
var useStyles = makeStyles(function () { return ({
    root: {
        cursor: 'pointer',
        borderRadius: 20,
    },
    content: {
        position: 'relative',
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        userSelect: 'none',
    },
    icon: {
        position: 'absolute',
        top: 5,
    },
    text: {
        position: 'absolute',
        bottom: 20,
    },
}); }, { name: 'SnCreateAreaCard' });
/**
 * 各アプリのオブジェクト作成時に使用するボタン
 */
export var CreateAreaCard = React.memo(function (props) {
    var width = props.width, height = props.height, Icon = props.Icon, text = props.text, onClick = props.onClick;
    var classes = useStyles();
    return (React.createElement(Card, { className: classes.root, onClick: onClick, width: width, height: height },
        React.createElement(CardContent, { className: classes.content },
            React.createElement(Icon, { width: 120, height: 120, className: classes.icon }),
            React.createElement(Typography, { bold: true, variant: "body1", className: classes.text }, text))));
});
